import React from 'react';
import {
    Container,
    RiskLevelTitle,
    SubTopicText,
    TopicText,
    StyledDivider,
    QuestionTitle,
    Question,
    Text
} from './ScoreCardItemDetails.style';
import { getAnswer } from '@Utils/scorecard';
import { withSize } from 'react-sizeme';

let ScoreCardItemDetails = ({
    riskColor,
    riskLevel,
    answerField,
    question,
    topic,
    subtopic,
    score,
    ...rest
}) => {
    let answer = typeof answerField === 'string' ? answerField : getAnswer(answerField);

    return (
        <Container riskColor={riskColor} {...rest}>
            <RiskLevelTitle riskColor={riskColor}>{riskLevel} risk</RiskLevelTitle>
            <TopicText>{topic}</TopicText>
            <SubTopicText>{subtopic}</SubTopicText>
            {question && (
                <>
                    <StyledDivider />
                    <QuestionTitle>
                        <Question>Question : </Question> <Text>{question}</Text>
                    </QuestionTitle>
                </>
            )}
            {answer && (
                <>
                    <QuestionTitle>
                        <Question>Answer : </Question> <Text>{answer}</Text>
                    </QuestionTitle>
                </>
            )}

            {score > -1 && (
                <>
                    <StyledDivider />
                    <QuestionTitle>
                        <Question>Score : </Question> <Text>{parseFloat(score).toFixed(2)}</Text>
                    </QuestionTitle>
                </>
            )}
        </Container>
    );
};

ScoreCardItemDetails = withSize({ monitorHeight: true })(ScoreCardItemDetails);

export { ScoreCardItemDetails };
